import { render } from "./ContractTemplateDetail.vue?vue&type=template&id=4f7404e2&scoped=true"
import script from "./ContractTemplateDetail.vue?vue&type=script&lang=js"
export * from "./ContractTemplateDetail.vue?vue&type=script&lang=js"

import "./ContractTemplateDetail.vue?vue&type=style&index=0&id=4f7404e2&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7404e2"]])

export default __exports__